import { z } from 'zod';

/**
 * Schema for recording a consultant hours credit or debit against an organization. Mirrors the
 * server rules: positive hours with at most two decimal places, optional description of at most
 * 1000 characters.
 */
export const consultantHoursTransactionSchema = z.object({
  type: z.enum(['Credit', 'Debit']),
  hours: z
    .number({ message: 'Hours must be a number' })
    .positive('Hours must be greater than 0')
    .max(99999999.99, 'Hours is too large')
    .refine((value) => Math.round(value * 100) / 100 === value, {
      message: 'Hours may have at most two decimal places',
    }),
  description: z.string().max(1000, 'Description must be at most 1000 characters'),
});

/**
 * TypeScript type inferred from schema
 */
export type ConsultantHoursTransactionForm = z.infer<typeof consultantHoursTransactionSchema>;
